var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trivia-result"},[(_vm.correct)?_c('div',{staticClass:"money-reward"},[_vm._v(" +"+_vm._s(_vm._f("currency")(_vm.amount))+" ")]):_c('SpinTracker',{attrs:{"addedSpins":_vm.amount}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }